import { render, staticRenderFns } from "./authCompetitionArea.vue?vue&type=template&id=4895c89a&scoped=true&"
import script from "./authCompetitionArea.vue?vue&type=script&lang=js&"
export * from "./authCompetitionArea.vue?vue&type=script&lang=js&"
import style0 from "./authCompetitionArea.vue?vue&type=style&index=0&id=4895c89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895c89a",
  null
  
)

export default component.exports